import { ProjectsService as PlatformProjectsService } from '../../platform/services/projects.service';

// Re-export platform ProjectsService to centralize project-related API calls.
export const ProjectsService = PlatformProjectsService;
